
import { Fragment } from "react";
import { Tooltip } from '@vds/tooltips';
function StartNotification(props) {
   
    const { label, tooltipTitle, tooltipMessage, showTooltip, dummyRibbon} = props||{};

    return (<Fragment>
              { <div className='current_plan_title' style={{ ...(dummyRibbon && { visibility: 'hidden' })}}>
                    {<span className="recommanded_title_label">{label}</span> }
                    { showTooltip && <Tooltip  title={tooltipTitle} size="small" surface="light"> {tooltipMessage} </Tooltip>}
                </div>
        }
        </Fragment>)

}

export default StartNotification;